import React from 'react'
import { Card, Row, Button, Typography, Select, List, Avatar, Divider } from 'antd';
import { StarFilled } from '@ant-design/icons';
import gift from '../../assets/KarmaIcons/gift.png';
import BoltSvg from '../../assets/KarmaIcons/bolt';
import Trophy from '../../assets/KarmaIcons/Trophy';

const { Title, Text } = Typography;
const { Option } = Select;

const performersData = [
  {
    id: 1,
    name: 'Alex Johnson',
    title: 'Frontend Developer',
    points: 600,
  },
  {
    id: 2,
    name: 'Priya Mehta',
    title: 'UX Designer',
    points: 270,
  },
  {
    id: 3,
    name: 'John Doe',
    title: 'Project Manager',
    points: 250,
  },
];



const Karmaleaderboard = () => {

  return (
    <div className='karma-wrapper'>
      <Row gutter={ 24 } className='karma-button-wrapper'>

        <Button type="primary" icon={ <StarFilled /> } className="send-karma-btn">
          <strong>           Send Karma via Econnect </strong>

          <div id="container-stars">
            <div id="stars"></div>
          </div>

          <div id="glow">
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </Button>


        <Button className="redeem-rewards-btn btn-shine">
          <span>
            <img src={ gift } />
            Redeem Rewards</span>
        </Button>

      </Row>

      <Card className="stats-card top-performers-card"
      >
        <div className='performers-header-wrapper'>
          <div className='top-performers-header'>
            <Trophy />
            <h2>Top Performers</h2>
          </div>
          <Select defaultValue="this-month" style={ { width: 120 } }>
            <Option value="this-month">This Month</Option>
            <Option value="last-month">Last Month</Option>
            <Option value="all-time">All Time</Option>
          </Select>
        </div>
        <Divider />
        <List
          dataSource={ performersData }
          renderItem={ item => (
            <List.Item

            >
              <div className='performers-wrapper'>
                <List.Item.Meta
                  avatar={
                    <Avatar
                    >
                      { item.id }
                    </Avatar>
                  }
                />
                <div className='performers-name-wrapper'>
                  <div className='performers-name'>
                    <h3>{ item.name }</h3>
                  </div>
                  <div className='performers-title'>
                    <p>{ item.title } </p>
                  </div>
                </div>
              </div>
              <div className='points-wrapper'>
                <Text >{ item.points }</Text>
                <span role="img" aria-label="lightning" ><BoltSvg /> </span>
              </div>
            </List.Item>
          ) }
        />
      </Card>
    </div>
  )
}

export default Karmaleaderboard
